// Email Util
import app from '../app.jsx'
import _ from 'lodash'
import { logger } from '../lib/logging'
import { MAIL_SERVICES_TIMEOUT } from '../../shared/constants'

class EmailUtil {
  getEmailSuggestions (contact) {
    if (contact && contact.contactPersons) {
      const persons = contact.contactPersons
      const tagsData = _.uniqBy(persons, (person) => (person.email))
      return tagsData.map((tagObj, _idx) => {
        let mailOption = `${tagObj.email} (${tagObj.name})`

        if (!tagObj.name) {
          mailOption = `${tagObj.email}`
        }

        tagObj.key = mailOption

        return mailOption
      })
    }

    return []
  }

  debugEmailAddressComparison (mail, contactPersons, documentName, ID) {
    const regex = this.emailWithNameInBracketsRegex()

    if (regex.test(mail.text)) {
      logger.error(`
        emailutil: invalid email address when sending ${documentName} ${ID}, 
        contactPersonEmails: ${contactPersons.map(c => c.email).join(', ')},
        contactPersonKey: ${contactPersons.map(c => c.key).join(', ')},
        mail.text: ${mail.text}
      `)
    }
  }

  // Sometimes an email address has a name in brackets behind it (SUP-1699). This method exist to
  // debug this issue and sanitize the faulty email address so the email doesn't bounce.
  emailWithNameInBracketsRegex () {
    return /(^[^@]+@[^@]+\.\w+?)\s\(.*\)/
  }

  debugExternalEmail (email) {
    const regex = this.emailWithNameInBracketsRegex()

    if (regex.test(email)) {
      logger.error(`emailutil: invalid (external) email: ${email}`)
    }
  }

  sanitizeEmail (email) {
    const regex = this.emailWithNameInBracketsRegex()

    return regex.test(email)
      ? email.replace(regex, '$1')
      : email
  }

  sanitizeEmails (emails) {
    return emails.map(email => {
      return this.sanitizeEmail(email)
    })
  }

  sendInvoiceMail (mailObj, invoice, sendMailWithDetails, resendMail) {
    const mailData = this.buildMailData('invoice', mailObj, invoice)

    const params = {
      query: {
        isActual: sendMailWithDetails
      }
    }

    if (resendMail) {
      params.query.bResend = true
    }

    app.service('/api/invoice/mail').timeout = MAIL_SERVICES_TIMEOUT
    return app.service('/api/invoice/mail').create(mailData, params)
  }

  sendEstimateMail (mailObj, estimate) {
    const mailData = this.buildMailData('estimate', mailObj, estimate)
    const params = { query: {} }

    app.service('/api/estimate/mail').timeout = MAIL_SERVICES_TIMEOUT
    return app.service('/api/estimate/mail').create(mailData, params)
  }

  sendPurchaseOrdeMail (mailObj, purchaseorder) {
    const mailData = this.buildMailData('purchaseorder', mailObj, purchaseorder)
    const params = { query: { } }

    app.service('/api/purchaseorder/mail').timeout = MAIL_SERVICES_TIMEOUT
    return app.service('/api/purchaseorder/mail').create(mailData, params)
  }

  buildMailData (documentName, mailObj, document) {
    const contactPersons = document?.contact?.contactPersons?.length > 0
      ? document.contact.contactPersons
      : []

    const emails = mailObj?.toEmails?.length > 0
      ? this.buildEmailList(mailObj, contactPersons, documentName)
      : []

    return {
      toEmails: this.sanitizeEmails(emails),
      ccEmails: mailObj.ccEmails ? mailObj.ccEmails.map(mail => this.sanitizeEmail(mail.text)) : [],
      subject: mailObj.subject,
      content: mailObj.content,
      files: mailObj.files,
      [documentName + 'Id']: document.id
    }
  }

  buildEmailList (mailObj, contactPersons, documentName) {
    return mailObj.toEmails.map((mail) => {
      const matchingContactPerson = contactPersons.find((contactPerson) => {
        return mail.text === contactPerson.key
      })

      if (matchingContactPerson) {
        return matchingContactPerson.email
      } else {
        this.debugEmailAddressComparison(mail, contactPersons, documentName, document.id)
        return mail.text
      }
    })
  }
}

export default new EmailUtil()
